import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MerchantPageShell from "../../components/merchant/MerchantPageShell";
import { login } from "../../lib/authApi";
import { clearShopperToken, clearVeyaTeamToken } from "../../lib/api";
import { useSession } from "../../hooks/useSession";

export default function MerchantLogin({ rightAction }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshSession } = useSession();
  const requestedPath = location.state?.from || null;

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const email = form.email.trim();
    const password = form.password.trim();

    if (!email || !password) {
      setError("Email and password are required.");
      return;
    }

    setError("");
    setSubmitting(true);

    try {
      clearShopperToken();
      clearVeyaTeamToken();

      await login({ email, password });
      await refreshSession();

      if (requestedPath) {
        navigate(requestedPath, { replace: true });
        return;
      }

      navigate("/merchant/dashboard/catalog", { replace: true });
    } catch (err) {
      console.error("Login failed", err);
      setError(err?.message || "Could not log in");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <MerchantPageShell rightAction={rightAction}
      eyebrow="Merchant Account"
      title="Merchant login"
      lede="Sign in if your boutique has already been approved for Veya merchant access."
    >
      <form className="merchant-form" onSubmit={handleSubmit}>
        <label className="merchant-field">
          <span className="merchant-label">Email</span>
          <input
            className="merchant-input"
            type="email"
            value={form.email}
            onChange={(e) => updateField("email", e.target.value)}
            placeholder="hello@yourstore.com"
          />
        </label>

        <label className="merchant-field">
          <span className="merchant-label">Password</span>
          <input
            className="merchant-input"
            type="password"
            value={form.password}
            onChange={(e) => updateField("password", e.target.value)}
            placeholder="Enter your password"
          />
        </label>

        {error ? <p className="merchant-error">{error}</p> : null}

        <div className="merchant-actions">
          <button className="gold-btn" type="submit" disabled={submitting}>
            {submitting ? "Signing in..." : "Sign in"}
          </button>

          <Link className="public-navlink" to="/merchant/apply">
  Apply to partner
</Link>
        </div>
      </form>
    </MerchantPageShell>
  );
}